'use client'

import { useEffect } from 'react'
import NextError from 'next/error'
import * as Sentry from '@sentry/nextjs'

interface GlobalErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function GlobalError({ error, reset }: GlobalErrorProps) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  // Raw hex values mirroring the semantic tokens in src/theme/foundations/colors.ts
  // (app.bg, surface/white, border/gray.200, text/gray.900, text.secondary/gray.600,
  // accent/brand.500). This file renders outside the Chakra providers, so theme
  // tokens are unavailable and the equivalents must be inlined.
  return (
    <html lang="en">
      <body
        style={{
          alignItems: 'center',
          background: '#f4f8fc',
          color: '#1b1815',
          display: 'flex',
          fontFamily: 'system-ui, sans-serif',
          justifyContent: 'center',
          margin: 0,
          minHeight: '100vh',
          padding: '24px',
        }}
      >
        <main
          style={{
            background: '#ffffff',
            border: '1px solid #e7e5e0',
            borderRadius: '12px',
            boxShadow: '0 20px 40px rgba(15, 23, 42, 0.08)',
            maxWidth: '480px',
            padding: '32px',
            textAlign: 'center',
            width: '100%',
          }}
        >
          <NextError statusCode={500} />
          <button
            onClick={() => reset()}
            style={{
              background: '#2563eb',
              border: 0,
              borderRadius: '8px',
              color: '#ffffff',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: 600,
              marginTop: '24px',
              padding: '12px 20px',
            }}
            type="button"
          >
            Try again
          </button>
          {process.env.NODE_ENV === 'development' && error.digest ? (
            <p style={{ color: '#57514a', fontSize: '0.875rem', margin: '16px 0 0' }}>
              Error digest: {error.digest}
            </p>
          ) : null}
        </main>
      </body>
    </html>
  )
}
